import React, { useState, useEffect } from 'react';
import { Box, Typography, Tabs, Tab } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import DatePickerMui from '../../common/DatePickerMui';
import DashBoardTable from './components/Table';
import moment from 'moment';
import axios from 'axios';

const useStyles = makeStyles({
  container: {
    marginTop: 0,
    padding: '18.4px'
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
    backgroundColor: '#f8fbff',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  },
  title: {
    color: '#343a40',
    fontWeight: 'bold',
  },
  tabsContainer: {
    marginBottom: '20px'
  },
  tab: {
    textTransform: 'none',
    fontWeight: 'bold'
  }
});

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`rejection-analysis-tabpanel-${index}`}
      aria-labelledby={`rejection-analysis-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

const RejectionAnalysis = () => {
  const classes = useStyles();
  const urlParams = new URLSearchParams(window.location.search);
  const dateParam = urlParams.get('date');
  const initialDate = dateParam ? moment(decodeURIComponent(dateParam)) : moment();
  
  const [selectedDate, setSelectedDate] = useState(initialDate);
  const [tabValue, setTabValue] = useState(0);
  const [departmentData, setDepartmentData] = useState(null);
  const [partData, setPartData] = useState(null);

  const handleDateChange = (date) => {
    if (date) {
      setSelectedDate(moment(date));
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const formatDateForApi = (date) => {
    return encodeURIComponent(date.toDate().toUTCString());
  };

  const fetchDepartmentData = async () => {
    try {
      const formattedDate = formatDateForApi(selectedDate);
      const response = await axios.get(`/api/getRejectionDataDepartmentWise?date=${formattedDate}`);
      setDepartmentData(response.data);
    } catch (error) {
      console.error('Error fetching department-wise rejection data:', error);
    }
  };

  const fetchPartData = async () => {
    try {
      const formattedDate = formatDateForApi(selectedDate);
      const response = await axios.get(`/api/getRejectionDataPartWise?date=${formattedDate}`);
      setPartData(response.data);
    } catch (error) {
      console.error('Error fetching part-wise rejection data:', error);
    }
  };

  useEffect(() => {
    fetchDepartmentData();
    fetchPartData();
  }, [selectedDate]);

  return (
    <Box className={classes.container}>
      <Box className={classes.headerContainer}>
        <Typography variant="h6" className={classes.title}>
          Rejection Analysis
        </Typography>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <DatePickerMui
            label="Select Date"
            value={selectedDate ? selectedDate.toDate() : null}
            onChange={handleDateChange}
            views={['month', 'year']}
            format="MMMM yyyy"
            openTo="month"
          />
        </MuiPickersUtilsProvider>
      </Box>

      <Box className={classes.tabsContainer}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab label="Department-wise Analysis" className={classes.tab} />
          <Tab label="Part-wise Analysis" className={classes.tab} />
        </Tabs>
      </Box>

      <TabPanel value={tabValue} index={0}>
        {departmentData && (
          <DashBoardTable
            tableData={departmentData}
            frozenColumns={1}
          />
        )}
      </TabPanel>

      <TabPanel value={tabValue} index={1}>
        {partData && (
          <DashBoardTable
            tableData={partData}
            frozenColumns={1}
          />
        )}
      </TabPanel>
    </Box>
  );
};

export default RejectionAnalysis;